export const SET_VIEW = 'SET_VIEW'
export const SET_DAYS = 'SET_DAYS'
export const SET_STATUS = 'SET_STATUS'
export const SET_END_DATE = 'SET_END_DATE'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_START_DATE = 'SET_START_DATE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'

export const SESSION_DAYS = 'dashboard/days'
export const SESSION_VIEW = 'dashboard/view'
export const SESSION_STATUS = 'dashboard/status'
export const SESSION_END_DATE = 'dashboard/endDate'
export const SESSION_PAGE_SIZE = 'dashboard/pageSize'
export const SESSION_START_DATE = 'dashboard/startDate'
export const SESSION_SEARCH_TERM = 'dashboard/searchTerm'

export const SET_TECH = 'SET_TECH'
export const COMPANY_NUMBER_SCANS_OVERALL = 'COMPANY_NUMBER_SCANS_OVERALL'
export const COMPANY_NUMBER_SCANS = 'COMPANY_NUMBER_SCANS'
export const COMPANY_AVG_SCAN_TIMES = 'COMPANY_AVG_SCAN_TIMES'
export const PERSONAL_YESTERDAY_SCANS = 'PERSONAL_YESTERDAY_SCANS'
export const PERSONAL_AVG_SCANS = 'PERSONAL_AVG_SCANS'
export const PERSONAL_AVG_SCAN_TIMES = 'PERSONAL_AVG_SCAN_TIMES'
export const PERSONAL_AVG_CYCLE_TIMES = 'PERSONAL_AVG_CYCLE_TIMES'

export const SESSION_COMPANY_NUMBER_SCANS_OVERALL = 'SESSION_COMPANY_NUMBER_SCANS_OVERALL'
export const SESSION_COMPANY_NUMBER_SCANS = 'SESSION_COMPANY_NUMBER_SCANS'
export const SESSION_COMPANY_AVG_SCAN_TIMES = 'SESSION_COMPANY_AVG_SCAN_TIMES'
export const SESSION_PERSONAL_YESTERDAY_SCANS = 'SESSION_PERSONAL_YESTERDAY_SCANS'
export const SESSION_PERSONAL_AVG_SCANS = 'SESSION_PERSONAL_AVG_SCANS'
export const SESSION_PERSONAL_AVG_SCAN_TIMES = 'SESSION_PERSONAL_AVG_SCAN_TIMES'
export const SESSION_PERSONAL_AVG_CYCLE_TIMES = 'SESSION_PERSONAL_AVG_CYCLE_TIMES'



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/types.js